import axios from 'axios'
import router from '../../../router'
import { Decimal } from 'decimal.js'
export default {
    OpenUrl:function (url,query,needquery) {
        var routes=router.getRoutes();
        for (let i in routes){
            if(url==routes[i].path){
                if(needquery===false || needquery==='false') {
                    this.$store.commit('add_tagsview', Object.assign(routes[i]));
                }else{
                    this.$store.commit('add_tagsview', Object.assign(routes[i], {'query': query}));
                }
                break;
            }
        }
        const queryparams = {
            ...query
        };
        if(needquery===false || needquery==='false') queryparams.needquery=false;
        router.push({path:url,query:queryparams}).catch(function (err){console.log(err)});
    },
    close_tag:function (route){
        var state=this.$store.state.tagsview.allviews;
        for (let [i, v] of state.entries()) {
            if (v.path == route.path) {
                if(state[i-1]) this.OpenUrl(state[i-1].path,state[i-1].query);
                else this.OpenUrl('/');
            }
        }
        this.$store.commit('del_tagsview',route);
    },
    RequestApi:function (url,data,headers){
        let header=Object.assign({'content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},headers);
        return new Promise((resolve) => {
            axios.interceptors.request.use(
                config => {
                    const token = localStorage.getItem('qfyutoken');
                    token && (config.headers.qfyuauthorize = token);
                    return config;
                },error => {
                    return Promise.error(error);
                });
            axios({
                method: typeof data == "object" ? 'POST' : 'GET',
                url: this.ApiUrl + this.ApiModule + url,
                data: data ? data : {},
                headers: header,
                responseType: 'json',
            }).then(res => {
				console.log("请求返回的结果:",res)
                if (res.status == 200) {
                    if (res.data.status == 403) {
                        //resolve({'status':403,'msg':res.data.msg});
                        this.TipsError(res.data.msg);
                    }else if(res.data.status == 401){
                        this.$store.commit('add_exclude',{name:'Dashboard'});
                        this.$store.commit('clear_tagsview');
                        this.OpenUrl('/login');
                    }else {
                        resolve(res.data);
                    }
                }
            }).catch(err => {
                this.TipsError('请求失败',4.5);
                console.log(err);
            })
        })
    },
    TipsError:function (txt,duration){
        this.$message({
            message: txt,
            duration:(typeof duration=="undefined")?6000:duration*1000,
            showClose:duration?false:true,
            type: 'error'
        });
        return false;
    },
    TipSuccess:function (txt){
        this.$message({
            message: txt,
            duration:1000,
            showClose:false,
            type: 'success'
        });
        return false;
    },
    confirm:function (txt,succ,fail){
        this.$confirm(txt, '提示', {
            type:'warning ',
            dangerouslyUseHTMLString:true
        }).then(function (){
            if(typeof succ=='function') succ();
        }).catch(function (){
            if(typeof fail=='function') fail();
        })
    },
    pageSizeOpts:function (pageSize,small){
        if(!pageSize) pageSize=10;
        return typeof(small)!='undefined'?[parseInt(pageSize/2),pageSize,pageSize*2,pageSize*3]:[parseInt(pageSize/2),pageSize,pageSize*2,pageSize*3,pageSize*5,pageSize*10]
    },
    checkBtn:function (btnArray,btn){
        if(btnArray && btnArray.indexOf(btn)>-1) return true;
        else return false;
    },
    /**
     * 获取当前日期时间
     * @param isTime // 拼接H:i:s 默认false
     */
    getNowDate(isTime){
        isTime = isTime || false
        const myDate = new Date();
        let nowDate = myDate.getFullYear() + '-' + this.pZeroLeft((myDate.getMonth() + 1),2) + '-' + this.pZeroLeft(myDate.getDate(),2), nowTime = ''
        if(isTime) nowTime = ' ' + this.pZeroLeft(myDate.getHours(),2) + ':' + this.pZeroLeft(myDate.getMinutes(),2) + ':' + this.pZeroLeft(myDate.getSeconds(),2)
        return nowDate + nowTime
    },
    getTomorrow(isTime){
        isTime = isTime || false
        const today = new Date();
        const myDate=new Date(today.setDate(today.getDate()+1));
        let nowDate = myDate.getFullYear() + '-' + this.pZeroLeft((myDate.getMonth() + 1),2) + '-' + this.pZeroLeft(myDate.getDate(),2), nowTime = ''
        if(isTime) nowTime = ' ' + this.pZeroLeft(myDate.getHours(),2) + ':' + this.pZeroLeft(myDate.getMinutes(),2) + ':' + this.pZeroLeft(myDate.getSeconds(),2)
        return nowDate + nowTime
    },
    /**
     * 向左补零
     * @param num
     * @param n //补零个数
     */
    pZeroLeft(num, n) {
        return (Array(n).join(0) + num).slice(-n);
    },
    /**
     * 基本运算
     * @param arg1
     * @param arg2
     * @param op 加法：+ 减法：- 乘法：* 除法：/
     * @param n 保留几位小数
     * @returns {string|number}
     */
    calculation:function(arg1, arg2, op, n){
        var r1, r2
        try {
            r1 = arg1.toString().split(".")[1].length
        }catch (e) {
            r1 = 0
        }
        try {
            r2 = arg2.toString().split(".")[1].length
        }catch (e) {
            r2 = 0
        }
        n = n || ((r1 >= r2) ? r1 : r2)
        if(typeof (arg1) == "undefined" || arg1 == undefined || arg1 == null || isNaN(parseFloat(arg1))) arg1 = 0;
        if(typeof (arg2) == "undefined" || arg2 == undefined || arg2 == null || isNaN(parseFloat(arg2))) arg2 = 0;
        arg1 = parseFloat(arg1);
        arg2 = parseFloat(arg2);
        let total = 0;
        if(op === '+'){ //加法
            total = new Decimal(arg1).add(new Decimal(arg2));
        }else if(op === '-'){ //减法
            total = new Decimal(arg1).sub(new Decimal(arg2));
        }else if(op === '*'){ //乘法
            total = new Decimal(arg1).mul(new Decimal(arg2));
        }else if(op === '/'){ //除法
            total = new Decimal(arg1).div(new Decimal(arg2));
        }
        total = total==0?0:this.getFixed(total.toNumber(),n);
        return total;
    },
    /**
     * 四舍五入小数点
     * @param arg1
     */
    getFixed:function(arg1,n) {
        if (typeof (arg1) == "undefined" || arg1 == undefined || arg1 == null || isNaN(parseFloat(arg1))) arg1 = 0;
        arg1 = parseFloat(arg1);
        return arg1.toFixed(n);
    },
}